import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import ApiCaller from './ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var fdpAddBasketActionEnum;
(function (fdpAddBasketActionEnum) {
    fdpAddBasketActionEnum["increase"] = "INCREASE_UNIT";
    fdpAddBasketActionEnum["decrease"] = "DECREASE_UNIT";
})(fdpAddBasketActionEnum || (fdpAddBasketActionEnum = {}));
export var basketActionsEnum;
(function (basketActionsEnum) {
    basketActionsEnum["ADD_TO_BASKET_REQUEST"] = "ADD_TO_BASKET_REQUEST";
    basketActionsEnum["ADD_TO_BASKET_SUCCESS"] = "ADD_TO_BASKET_SUCCESS";
    basketActionsEnum["ADD_TO_BASKET_ERROR"] = "ADD_TO_BASKET_ERROR";
    basketActionsEnum["EDIT_ITEM_QUANTITY_IN_BASKET_REQUEST"] = "EDIT_ITEM_QUANTITY_IN_BASKET_REQUEST";
    basketActionsEnum["EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS"] = "EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS";
    basketActionsEnum["EDIT_ITEM_QUANTITY_IN_BASKET_ERROR"] = "EDIT_ITEM_QUANTITY_IN_BASKET_ERROR";
})(basketActionsEnum || (basketActionsEnum = {}));
export function addItemToBasket(items = [], listings = [], ignoreErrorCodes = [], assuredPayload) {
    return (dispatch) => {
        dispatch({
            type: basketActionsEnum.ADD_TO_BASKET_REQUEST
        });
        let cartContext = assuredPayload ||
            items.reduce((p, item) => Object.assign(p, {
                [item.listingId]: {
                    quantity: item.quantity
                }
            }), {});
        const requestBody = {
            browseContext: {
                marketplace: 'GROCERY',
                listings
            },
            browseCartContext: {
                cartContext
            }
        };
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/cart/browse',
            acceptErrors: true,
            action: basketActionsEnum.ADD_TO_BASKET_REQUEST
        }), requestBody).then(json => {
            const response = json.RESPONSE;
            const error = Object.keys(cartContext).reduce((prev, curr) => {
                const { errorCode, errorMessage } = get(response, ['cartData', curr], {});
                if (!isEmpty(prev))
                    return prev;
                if ((errorCode || errorMessage) && ignoreErrorCodes.indexOf(errorCode) === -1) {
                    return { errorCode, errorMessage };
                }
                return prev;
            }, {});
            if (!isEmpty(error)) {
                dispatch({
                    type: basketActionsEnum.ADD_TO_BASKET_SUCCESS,
                    data: response
                });
                return Promise.reject(error);
            }
            return Promise.resolve(dispatch({
                type: basketActionsEnum.ADD_TO_BASKET_SUCCESS,
                data: response
            }));
        }, err => {
            const error = err.ERROR_MESSAGE
                ? { errorMessage: err.ERROR_MESSAGE }
                : {
                    errorMessage: stringTemplate('addtoBasketDegradeMessage')
                };
            dispatch({
                type: basketActionsEnum.ADD_TO_BASKET_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
export function editItemQuantityInBasket(items = [], listings = [], ignoreErrorCodes = [], assuredPayload) {
    return (dispatch) => {
        dispatch({
            type: basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_REQUEST
        });
        let cartContext = assuredPayload ||
            items.reduce((p, item) => Object.assign(p, {
                [item.listingId]: {
                    quantity: item.quantity
                }
            }), {});
        const requestBody = {
            browseContext: {
                marketplace: 'GROCERY',
                listings
            },
            browseCartContext: {
                cartContext
            }
        };
        return ApiCaller.put(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/cart/browse',
            acceptErrors: true,
            action: basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_REQUEST
        }), requestBody).then(json => {
            const response = json.RESPONSE;
            const error = Object.keys(cartContext).reduce((prev, curr) => {
                const { errorCode, errorMessage } = get(response, ['cartData', curr], {});
                if (!isEmpty(prev))
                    return prev;
                if ((errorCode || errorMessage) && ignoreErrorCodes.indexOf(errorCode) === -1) {
                    return { errorCode, errorMessage };
                }
                return prev;
            }, {});
            if (!isEmpty(error)) {
                dispatch({
                    type: basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS,
                    data: response
                });
                return Promise.reject(error);
            }
            return Promise.resolve(dispatch({
                type: basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS,
                data: response
            }));
        }, err => {
            const error = err.ERROR_MESSAGE
                ? { errorMessage: err.ERROR_MESSAGE }
                : {
                    errorMessage: stringTemplate('addtoBasketDegradeMessage')
                };
            dispatch({
                type: basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
